export const zh = {
  // Header
  home: "首页",
  pricing: "定价",
  features: "特点",
  faq: "常见问题",
  aiGenerator: "AI 图像生成器",
  login: "登录",

  // Hero Section
  heroTitle: "Lunabrush AI",
  heroSubtitle: "在几秒钟内创建令人惊叹的 AI 生成图像",
  worldFirstFree: "世界上第一个无限免费的 AI 图像生成器",
  hundredPercentFree: "100% 免费",
  poweredByFlux: "由 Flux19sv 提供支持",
  noLoginRequired: "无需登录",
  unlimitedGeneration: "无限生成",

  // AI Generator Section
  aiGeneratorTitle: "AI 图像生成器",
  freeTrial: "免费试用",
  describeImage: "描述您想要生成的图像...",
  generating: "生成中...",
  generatingPlease: "正在生成中请稍候......",
  generateImage: "生成图像",

  // Gallery Section
  inspiration: "获取灵感",
  inspirationDesc: "探索由 Lunabrush AI 生成的精彩图像",
  viewMore: "查看更多",

  // Image Gallery
  futuristicCity: "未来城市夜景，霓虹灯，赛博朋克风格",
  forestCabin: "森林中的神秘小屋，雾气缭绕",
  spaceAstronaut: "太空中的宇航员，星云背景",
  underwaterWorld: "水下世界，珊瑚礁，热带鱼",
  samurai: "古代日本武士，樱花飘落",
  mountainLake: "山间湖泊，日出，薄雾",
  spaceStation: "科幻太空站，行星背景",
  magicForest: "魔法森林，发光的蘑菇，精灵",

  // Features
  featuresTitle: "Lunabrush 的主要特点",
  featuresDesc: "我们不断改进我们的 AI 模型，为您提供最佳的图像生成体验",
  highQuality: "高质量生成",
  highQualityDesc: "使用最先进的 AI 模型生成令人惊叹的高质量图像",
  fastResponse: "快速响应",
  fastResponseDesc: "在几秒钟内获得您的 AI 生成图像，无需等待",
  privacyProtection: "隐私保护",
  privacyProtectionDesc: "您的提示和生成的图像受到严格的隐私保护",
  multipleStyles: "多种风格",
  multipleStylesDesc: "支持多种艺术风格，从写实到动漫，应有尽有",
  globalAvailable: "全球可用",
  globalAvailableDesc: "全球服务器分布，确保快速访问和生成",
  apiAccess: "API 访问",
  apiAccessDesc: "企业级 API 访问，轻松集成到您的应用程序中",

  // Stats
  statsTitle: "数百万用户的选择",
  statsDesc: "加入全球社区，探索 AI 图像生成的无限可能",
  registeredUsers: "注册用户",
  dailyImages: "每日生成图像",
  averageRating: "平均评分",
  millionPlus: "300万+",
  dailyCount: "1,530",
  rating: "4.9",

  // Testimonials
  testimonialsTitle: "用户对 Lunabrush AI 的评价",
  testimonialsDesc: "看看其他用户如何使用 Lunabrush AI 提升他们的创作流程",
  testimonial1Name: "李明",
  testimonial1Role: "UI/UX 设计师",
  testimonial1Content: "Lunabrush AI 彻底改变了我的设计流程。我可以快速生成概念图，节省了大量时间。图像质量令人惊叹！",
  testimonial2Name: "王晓华",
  testimonial2Role: "内容创作者",
  testimonial2Content:
    "作为一名内容创作者，我每天都需要大量的图像素材。Lunabrush AI 让我能够轻松生成独特的图像，大大提高了我的工作效率。",
  testimonial3Name: "张伟",
  testimonial3Role: "游戏开发者",
  testimonial3Content:
    "Lunabrush AI 的图像生成能力非常强大，特别是在创建游戏概念艺术方面。它帮助我们团队快速迭代创意，加速了开发过程。",

  // FAQ
  faqTitle: "常见问题",
  faqDesc: "查找有关我们的常见问题和解答",
  faq1Question: "为什么要用 Lunabrush AI？",
  faq1Answer:
    "Lunabrush AI 提供最先进的 AI 图像生成技术，用户一键即可创建精美图像！我们的模型经过特别训练，能够理解复杂的提示词，并生成高质量、细节丰富的图像。此外，我们还提供多种风格选择，满足不同创作需求。",
  faq2Question: "我可以升级或取消订阅吗？",
  faq2Answer:
    "当然！您可以随时在账户设置中升级或降级您的订阅计划。如果您决定取消订阅，可以在账户页面中轻松操作，我们不会收取任何额外费用。",
  faq3Question: "我可以获得退款吗？",
  faq3Answer: "不，我们不提供退款服务。",
  faq4Question: "你们会保存我的提示词吗？",
  faq4Answer:
    "是的，我们会保存您的提示词以改进我们的服务。但是，我们非常重视用户隐私，所有存储的提示词都经过匿名处理，不会与您的个人信息关联。如果您是付费用户，可以选择启用隐私模式，这样您的提示词将不会被保存。",
  faq5Question: "如果我订阅了 Ultimate，我可以获得更高质量的图像吗？",
  faq5Answer:
    "是的！Ultimate 订阅用户可以访问我们的高分辨率 (HD) 图像生成功能，生成的图像分辨率更高，细节更丰富。此外，Ultimate 用户还可以使用我们的专业模型，这些模型经过特别优化，能够生成更高质量的图像。",
  faq6Question: "如果我订阅，我还会看到广告吗？",
  faq6Answer: "订阅任何付费计划后，您将不会看到任何广告。我们希望为付费用户提供最佳的无干扰体验，让您专注于创作。",
  faq7Question: "我可以请求用户支持吗？",
  faq7Answer: "是的！您可以通过电子邮件 support@lunabrush.ai 联系我们，以获取技术支持和帮助。",
  faq8Question: "企业级服务是什么？",
  faq8Answer:
    "如果您需要特殊的解决方案，我们提供了企业级服务，包括专属支持、更高的使用限额、API 访问等。请联系 sales@lunabrush.ai 了解详情。",

  // Footer
  footerDesc: "Lunabrush AI 是 FLUX-LLM 技术的领先者，专注于 AI 图像生成",
  allRightsReserved: "Lunabrush AI 保留所有权利",
  tools: "工具",
  support: "支持",
  imageGallery: "图像画廊",
  termsOfService: "服务条款",
  privacyPolicy: "隐私政策",

  // Login Page
  welcomeTitle: "欢迎使用 Lunabrush AI",
  welcomeDesc: "选择您的登录方式开始创建令人惊叹的 AI 图像",
  googleLogin: "使用 Google 登录",
  githubLogin: "使用 GitHub 登录",
  loggingIn: "登录中...",
  loginTerms: "登录即表示您同意我们的",
  and: "和",

  // Create Page
  createImage: "创建图像",
  createDesc: "使用 Lunabrush AI 创建令人惊叹的图像",
  basic: "基础",
  advanced: "高级",
  prompt: "提示词",
  promptPlaceholder: "描述您想要生成的图像...",
  model: "模型",
  selectModel: "选择模型",
  negativePrompt: "负面提示词",
  negativePromptPlaceholder: "您不希望在图像中出现的内容...",
  aspectRatio: "宽高比",
  selectAspectRatio: "选择宽高比",
  promptStrength: "提示词强度",
  highQualityGeneration: "高质量生成 (需要更长时间)",
  preview: "预览",
  imageWillAppear: "您的图像将在这里显示",
  enterPrompt: "输入提示词并点击生成按钮",
  download: "下载",
  share: "分享",
  bookmark: "收藏",

  // Gallery Page
  galleryTitle: "图像画廊",
  galleryDesc: "探索由 Lunabrush AI 生成的精彩图像",
  searchPrompts: "搜索提示词...",
  sortBy: "排序方式",
  latest: "最新",
  popular: "最受欢迎",
  trending: "趋势",
  style: "风格",
  allStyles: "所有风格",
  realistic: "写实",
  anime: "动漫",
  digitalArt: "数字艺术",
  fantasy: "奇幻",
  loadMore: "加载更多",

  // Pricing
  choosePlan: "选择您的套餐",
  pricingDesc: "选择更快的生成速度与高级功能体验 Lunabrush AI 高级版特性",
  monthly: "月付",
  yearly: "年付",
  saveTwoMonths: "省两个月",
  advanced: "高级",
  personalUse: "适合个人使用",
  unlimitedGeneration: "无限图像生成",
  fastGeneration: "快速生成 (5 张/分钟)",
  noAds: "无广告",
  noWatermark: "无水印",
  upgradeToAdvanced: "升级到高级版",
  ultimate: "Ultimate",
  mostPopular: "最受欢迎",
  professionalCreators: "适合专业创作者",
  ultraFastGeneration: "极速生成",
  hdResolution: "高级HD分辨率",
  privateGeneration: "私有生成",
  advancedModels: "十高级模型支持",
  earlyAccess: "提前体验新功能",
  upgradeToUltimate: "升级到 Ultimate",
  enterprise: "Enterprise",
  custom: "自定义",
  teamsAndEnterprises: "适合团队和企业",
  customSolutions: "定制解决方案",
  dedicatedSupport: "专属支持",
  teamIntegration: "团队工具集成",
  highVolume: "大容量",
  contactUs: "联系我们",

  // Style Options
  style: "风格",
  noStyle: "无风格",
  digitalArt: "数字艺术",
  cyberpunk: "赛博朋克",
  lineArt: "线条艺术",
  photography: "摄影",
  film: "胶片",
  origami: "折纸",
  model3d: "3D模型",
  anime: "动漫",
  fantasyArt: "幻想艺术",
  lowPoly: "低多边形",
  cinematic: "电影感",
  enhanced: "增强",
  comicBook: "漫画书",
  isometric: "等距",
  clay: "黏土",

  // Color Tone Options
  colorTone: "色调",
  noColor: "无色彩",
  warmTones: "暖色调",
  coolTones: "冷色调",
  softColors: "柔和的色彩",
  vibrantColors: "鲜艳的色彩",
  pastelColors: "粉彩色",
  blackAndWhite: "黑白",

  // Lighting Options
  lighting: "光照",
  noLighting: "无光照",
  dramatic: "戏剧性",
  dimLighting: "昏暗的灯光",
  studio: "工作室",
  lowLight: "弱光",
  goldenHour: "黄金时段",
  backlight: "逆光",
  volumetricLight: "体积光",
  tyndallEffect: "丁达尔效应",
  sunlight: "阳光",
  rimLight: "轮廓光",

  // Composition Options
  composition: "构图",
  noComposition: "无构图",
  blurredBackground: "模糊背景",
  closeUp: "特写",
  wideAngle: "广角",
  shallowDepthOfField: "窄景深",
  bottomUpShot: "自下而上拍摄",
  topDownShot: "自上而下拍摄",
  macroPhotography: "微距摄影",

  // API相关错误信息
  promptRequired: "请输入提示词",
  generateFailed: "图像生成失败，请重试",
  unknownError: "未知错误",
  quotaExceeded: "生成配额已用完，请稍后再试",
  inappropriateContent: "检测到不当内容，请修改提示词",
  unexpectedResponse: "服务器响应异常",
  downloadFailed: "下载失败",
  shareFailed: "分享失败",
  linkCopied: "链接已复制到剪贴板",
  imageLoadFailed: "图像加载失败",
  authError: "认证失败",
  loginFailed: "登录失败",
  loginInitFailed: "登录初始化失败",
  loadImagesFailed: "加载图像失败",
  loading: "加载中",
  noMoreImages: "没有更多图像了",

  // 通用
  close: "关闭",
} as const
